import { withStyles } from "@material-ui/core";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

export const styles = (theme) => ({
	root: {
		width: "100%",
		height: 200,
		padding: 20,
		display: "flex",
		textAlign: "center",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#F4F6F7",
	},
	minimal: {
		backgroundColor: "transparent",
	},
	icon: {
		color: theme.palette.text.accessible,
		width: 48,
		height: 48,
	},
	text: {
		...theme.typography.h4,
		color: theme.palette.text.accessible,
		margin: "18px 0 0 0",
		fontWeight: "normal",
	},
});

/**
 * Rendered when the dashboard list contains no items.
 * @param {Object} props - React props
 * @returns {React.Component} A non-ideal state for when no permit results are found.
 */
export const EmptyState = ({ Icon, classes, minimal, children }) => (
	<div
		className={classnames({
			[classes.root]: true,
			[classes.minimal]: minimal,
		})}
	>
		<div className={classes.content}>
			{Icon && <Icon className={classes.icon} />}
			<p className={classes.text}>{children}</p>
		</div>
	</div>
);

EmptyState.propTypes = {
	Icon: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
	minimal: PropTypes.bool,
	classes: PropTypes.shape({}).isRequired,
	children: PropTypes.node.isRequired,
};

EmptyState.defaultProps = {
	minimal: false,
};

export default withStyles(styles)(EmptyState);
